import { Box, ListItemButton, ListItemIcon, ListItemText, Paper } from "@mui/material";
import { useEffect, useState } from "react";
import Dashborad from "./Dashboard";
import Payment from "./Payment";
import Accounts from "./Account";
import Login from "./Login";
import { useNavigate } from "react-router-dom";
import ConfirmDialog from "../component/ConfirmDialog";
import DashboardIcon from '@mui/icons-material/Dashboard';
import PaymentIcon from '@mui/icons-material/Payment';
import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import LogoutIcon from '@mui/icons-material/Logout';




const Appview = () => {
    const [component, setComponent] = useState(<Dashborad />);
    const [selectedPath, setSelectedPath] = useState("/dashboard");
    const navigate = useNavigate();
    const [open, setOpen] = useState(false);

    useEffect(() => {
        console.log(localStorage.getItem("user"));
        // if (localStorage.getItem("user") === null) {
        //     navigate("/login")
        // }
    },)

    const handleConfirm = () => {
        // localStorage.clear();
        navigate("/login");
        setOpen(false);
    };

    const handleCancel = () => {
        setOpen(false);
    };

    const menus = [
        {
            name: "Dashboard",
            path: "/dashboard",
            icon: <DashboardIcon />
        },
        {
            name: "Payment",
            path: "/payment",
            icon: <PaymentIcon />
        },
        {
            name: "Accounts",
            path: "/accounts",
            icon: <AccountCircleIcon />
        },
        {
            name: "Logout",
            path: "/logout",
            icon: <LogoutIcon />
        }
    ];


    const loadComponent = (path) => {
        switch (path) {
            case "/dashboard":
                setComponent(<Dashborad />)
                setSelectedPath(path)
                break;

            case "/payment":
                setComponent(<Payment />)
                setSelectedPath(path)
                break;

            case "/accounts":
                setComponent(<Accounts />)
                setSelectedPath(path)
                break;
            case "/logout":
                setOpen(true)
                break;
            default:
                setComponent(<Login />);
                setSelectedPath(path);
                break;
        }
    }

    return (
        <Box sx={{
            width: "100%",
            height: "100dvh",
            display: "flex"
        }}>
            <ConfirmDialog
                open={open}
                title="Logout"
                message="Are you sure you want to Logout?"
                onConfirm={handleConfirm}
                onCancel={handleCancel}
            />
            <Box sx={{
                width: "20%",
                height: "100vh",
            }}>
                <Paper elevation={3} sx={{ height: "100vh", backgroundColor: "#6a1b9a", color: "white" }}>
                    <Box sx={{
                        height: "10vh",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        fontSize: "30px",
                        backgroundColor: "#8e24aa", // Purple Brand Bar
                        color: "white",
                        fontWeight: "bold",
                        mb: 2
                    }}>
                        LedgerHub
                    </Box>
                    {menus.map((menu) => (
                        <ListItemButton
                            key={menu.path}
                            sx={{
                                '&:hover': {
                                    backgroundColor: '#ab47bc', // Lighter purple on hover
                                    color: 'white'
                                },
                                backgroundColor: selectedPath === menu.path ? '#7b1fa2' : 'transparent', // Dark purple when selected
                                color: 'white',
                                borderRadius: '8px',
                                margin: '4px',
                            }}
                            onClick={() => loadComponent(menu.path)}
                        >
                            <ListItemIcon sx={{ color: 'inherit', minWidth: '35px' }}>
                                {menu.icon}
                            </ListItemIcon>

                            <ListItemText primary={menu.name} />
                        </ListItemButton>
                    ))}
                </Paper>


            </Box>

            <Box sx={{
                width: "80%",
        
                backgroundColor: "#f3e5f5", // Very light purple background

            }}>
                {component}
            </Box>


        </Box>

    )

}
export default Appview;